import { render, staticRenderFns } from "./veSbzcZcApplyShow.vue?vue&type=template&id=572c483d&scoped=true"
import script from "./veSbzcZcApplyShow.vue?vue&type=script&lang=js"
export * from "./veSbzcZcApplyShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572c483d",
  null
  
)

export default component.exports